/**
 * Debug Utilities
 * 
 * Development-only debug logging helper
 * Production'da tüm log'lar otomatik olarak devre dışı bırakılır
 */

import { shouldSilenceApiLog } from '@/lib/api-route-log';

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * Development-only console.log wrapper
 */
export const debugLog = (...args: unknown[]): void => {
  if (isDevelopment) {
    console.log(...args);
  }
};

/**
 * Development-only console.warn wrapper
 */
export const debugWarn = (...args: unknown[]): void => {
  if (isDevelopment) {
    console.warn(...args);
  }
};

/**
 * Development-only console.error wrapper
 */
export const debugError = (...args: unknown[]): void => {
  if (isDevelopment) {
    console.error(...args);
  }
};

/**
 * Development-only console.debug wrapper
 */
export const debugDebug = (...args: unknown[]): void => {
  if (isDevelopment) {
    console.debug(...args);
  }
};

/**
 * Conditional logging with context
 */
export const debugLogWithContext = (context: string, ...args: unknown[]): void => {
  if (isDevelopment) {
    console.log(`[${context}]`, ...args);
  }
};

/**
 * Conditional error logging with context
 */
export const debugErrorWithContext = (context: string, error: unknown, details?: Record<string, unknown>): void => {
  if (isDevelopment) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    console.error(`[${context}]`, errorMessage, details || '');
  }
};

/**
 * Always log console.error (production'da da gerekli).
 * Build / prerender bailout (HANGING_PROMISE_REJECTION vb.) gürültüsünü susturur.
 */
export const logError = (...args: unknown[]): void => {
  if (shouldSilenceApiLog(...args)) return;
  console.error(...args);
};

